import React from 'react';

import CheckListForm from '../../Components/CheckListForm';

export default function CheckListCreator() {
  return (
    <div>
      <CheckListForm />
    </div>
  );
}
